import React from "react";

type BadgeProps = {
  children: any;
  status: "success" | "error" | "info" | "blueishblack" | "warning";
  small?: boolean;
  large?: boolean;
};

const Badge: React.FC<BadgeProps> = ({
  status,
  children,
  small,
  large,
}): React.ReactElement => {
  return (
    <span
      className={`px-2 py-1 w-fit rounded-sm text-white bg-${status} ${
        small ? "text-xs" : large ? "text-lg" : "text-base"
      }`}
    >
      {children}
    </span>
  );
};

export default Badge;
